import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
})
export class LogsComponent implements OnInit {
  users
  userLogs

  constructor( private firestore: AngularFirestore ) { }

  ngOnInit() {
    this.getUsersList()
  }

  getUsersList(){
    this.firestore.collection('logs').snapshotChanges()
    .subscribe(
      (res)=>{
        console.log('Logs page] users  ', res)
        this.users = []
        res.forEach(
          r=>{
            const userId = r.payload.doc.id
            this.firestore.collection('logs').doc(userId).valueChanges().subscribe(
              (usr)=>{
                console.log('Logs page] usr  ', usr)
                this.users.push( {key: userId, email: usr['email']} )

                console.log('Logs page] users2  ', this.users)
              }
            )
            
          }
        )
      }
    )
  }

  getUserLogs(userId){
    this.userLogs = []
    this.firestore.collection('logs/' + userId + '/accesslogs').valueChanges().subscribe(
      (res)=>{
        console.log('getUserLogs logs  ', res)
        res.sort(function (a, b) {
          if (a['date_time'] > b['date_time']) {
              return -1;
          }
          if (b['date_time'] > a['date_time']) {
              return 1;
          }
          return 0;
        })
        res.forEach(
          (log)=>{
            log['time'] = log['date_time'].toDate()
            this.userLogs.push(log)
          }
        )
        
      }
    )

  }

}
